/** @format */

export const initialState = {
  info: {},
  homeId: null,
  refetchHomes: () => {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setInfo':
      return { ...state, info: action.payload };
    case 'setHomeId':
      return { ...state, homeId: action.payload };
    case 'setRefetchHomes':
      return { ...state, refetchHomes: action.payload };
    default:
      return state;
  }
};
